






























import Vue, { PropType } from 'vue'
import { VueForm } from '@/utils/interfaces'
import { AsyncComponentPromise } from 'vue/types/options'

export default Vue.extend({
  props: {
    steps: {
      type: Array as PropType<[string, AsyncComponentPromise][]>,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    type: String,
  },
  computed: {
    currentComponent(): null | VueForm {
      const stepArray = this.$refs as { step: VueForm[] }
      if (stepArray.step) {
        return stepArray.step[this.value - 1]
      } else return null
    },
  },
  created() {
    this.steps.forEach(step => {
      if (this.$options.components && !this.$options.components[step[0]]) {
        this.$options.components[step[0]] = step[1]
      }
    })
  },
})
